import React from "react";
import * as Yup from "yup";
import {
  MODAL_STATES,
  generateManageJob,
  generateJobDetails,
  jobSummary,
} from "../../constant/Home/Jobs";
import { Formik, Form } from "formik";
import Jobs from "../common/Jobs/Jobs";
import Section from "../common/Details";
import GenericModal from "../../Ui/Modal";
import { Toaster } from "react-hot-toast";
import { JobsApi } from "../../../service";
import { Box, Button } from "@mui/material";
import CircularLoader from "../../Ui/Loader";
import ButtonComponent from "../../Ui/Button";
import FormField from "../../utils/FormFileds";
import useApiHandler from "../../hooks/ApiHandler";
import CompleteJobs from "./CompleteJobs/CompleteJobs";
import { UserContext } from "../../context/UserContext";
import { useContext, useState, useEffect, useRef } from "react";
import { searchbarVisibilty } from "../../constant/Home/Dashboard";
import { useStatisticsData } from "../../context/StatisticsData";
import { useCurrentSelectedData } from "../../context/CurrentSelectedDataContext";
import RescheduleTimeSlotPicker from "../Reschedule/RescheduleTimeSlotPicker";
const ActiveJobs = () => {
  const { userData } = useContext(UserContext);
  const [modalState, setModalState] = useState("");
  const { callApi, loading } = useApiHandler();
  const { currentSelectedData } = useCurrentSelectedData();
  const { refreshStatistics } = useStatisticsData();
  const formikSubmitRef = useRef(null);

  const [jobs, setJobs] = React.useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [resultsPerPage, setResultsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  const handleCancelJob = async () => {
    await callApi(
      () => JobsApi.cancelMaintenanceRequest(currentSelectedData?.id, ""),
      {
        onSuccess: (response) => {
          setJobs((prev) =>
            prev.filter((job) => job.id !== currentSelectedData?.id)
          );
          setModalState(MODAL_STATES.CANCELED_CONFIRMATION);
          refreshStatistics();
        },
        onError: (error) => {
          console.log("Error canceling job:", error);
        },
        successMessage: "Job canceled successfully!",
      }
    );
  };
  const getActiveJobs = async (opts = {}) => {
    const { silent } = opts;
    await callApi(() => JobsApi.getActiveJobs(currentPage, resultsPerPage), {
      silent,
      onSuccess: (response) => {
        if (response.data) {
          setJobs(response.data?.results || response.data);
          setTotalCount(response.data?.count || response.data?.length || 0);
        }
      },
      onError: (error) => {
        console.log(error);
      },
    });
  };

  // Handle results per page change
  const handleResultsPerPageChange = (newResultsPerPage) => {
    setResultsPerPage(newResultsPerPage);
    setCurrentPage(1); // Reset to first page when changing results per page
  };

  useEffect(() => {
    getActiveJobs();
  }, [currentPage, resultsPerPage]);

  // Refresh active jobs list during dashboard polling while this tab is mounted
  useEffect(() => {
    const onPoll = () => {
      getActiveJobs({ silent: true }).catch(() => {});
    };
    window.addEventListener("dashboard:poll", onPoll);
    return () => window.removeEventListener("dashboard:poll", onPoll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, resultsPerPage]);

  const ModifyJobSchema = Yup.object().shape({
    additionalWork: Yup.string()
      .trim()
      .required("Additional work details are required"),
    newEstimate: Yup.string().trim().required("Estimate is required"),
    media: Yup.mixed().nullable(),
  });
  const RescheduleJobSchema = Yup.object().shape({
    rescheduleReason: Yup.string()
      .trim()
      .required("Reschedule reason is required"),
    days_available: Yup.array()
      .of(Yup.string())
      .min(1, "Select at least one available time slot"),
  });

  const footer = {
    [MODAL_STATES.MANAGE_JOB]: (
      <div className="flex w-full justify-between gap-2 sm2:flex-row flex-col ">
        <ButtonComponent paddingY="10px" onClick={() => setModalState("")}>
          Back
        </ButtonComponent>
        <div className="flex md:gap-4 gap-2 sm2:flex-row flex-col">
          {userData?.accountType !== "TENANT" && (
            <ButtonComponent
              bgColor="#D40000"
              color="#FFFFFF"
              paddingY="10px"
              onClick={() => setModalState(MODAL_STATES.CANCEL_JOB)}
            >
              Cancel Job
            </ButtonComponent>
          )}

          {(() => {
            const status = (currentSelectedData?.status || "").toString().toUpperCase();
            const awaitingLandlord = [
              "OPEN",
              "PENDING",
              "PENDING_APPROVAL",
              "AWAITING_APPROVAL",
            ].includes(status);

            // Show special orange button for tenants while awaiting landlord action
            if (userData?.accountType === "TENANT" && awaitingLandlord) {
              return (
                <ButtonComponent
                  paddingY="10px"
                  bgColor="#FF8A00"
                  color="#FFFFFF"
                  disabled
                  title="Your landlord needs to approve this request before messaging is available."
                >
                  Awaiting landlord action
                </ButtonComponent>
              );
            }

            // Default Message Vendor button (same behavior as before)
            return (
              <ButtonComponent
                paddingY="10px"
                onClick={() => setModalState("")}
                bgColor="#3CAB5C"
                color="#FFFFFF"
                disabled={currentSelectedData?.status === "ASSIGNING_VENDOR"}
                title={
                  currentSelectedData?.status === "ASSIGNING_VENDOR"
                    ? "Messaging will be available once a vendor is assigned."
                    : undefined
                }
              >
                Message Vendor
              </ButtonComponent>
            );
          })()}
        </div>
      </div>
    ),
    [MODAL_STATES.CANCEL_JOB]: (
      <div className="flex w-full justify-between">
        <ButtonComponent
          paddingY="10px"
          onClick={() => setModalState(MODAL_STATES.MANAGE_JOB)}
        >
          Back
        </ButtonComponent>
        <ButtonComponent
          bgColor="#D40000"
          color="#FFFFFF"
          paddingY="10px"
          onClick={() => setModalState(MODAL_STATES.CANCEL_CONFIRM)}
        >
          Cancel Job
        </ButtonComponent>
      </div>
    ),
    [MODAL_STATES.CANCEL_CONFIRM]: (
      <div className="flex w-full justify-between">
        <ButtonComponent
          paddingY="10px"
          onClick={() => setModalState(MODAL_STATES.CANCEL_JOB)}
        >
          Back
        </ButtonComponent>
        <ButtonComponent
          bgColor="#D40000"
          color="#FFFFFF"
          paddingY="10px"
          onClick={() => handleCancelJob()}
        >
          Yes, Cancel Job
        </ButtonComponent>
      </div>
    ),
    [MODAL_STATES.CANCELED_CONFIRMATION]: (
      <div className="flex w-full justify-between">
        <ButtonComponent
          paddingY="10px"
          onClick={() => setModalState(MODAL_STATES.CANCEL_JOB)}
        >
          Back
        </ButtonComponent>
        <ButtonComponent
          bgColor="#D40000"
          color="#FFFFFF"
          hoverBgColor="#B00000"
          hoverBorderColor="#B00000"
          paddingY="10px"
          onClick={() => setModalState("")}
        >
          Exit
        </ButtonComponent>
      </div>
    ),
    [MODAL_STATES.JOB_DETAILS]: (
      <div className="flex w-full justify-center sm1:flex-row flex-col md:gap-[34px] gap-1">
        <ButtonComponent
          bgColor="#52C171"
          color="#FFFFFF"
          paddingY="10px"
          onClick={() => setModalState(MODAL_STATES.COMPLETE_JOB)}
        >
          Complete Job
        </ButtonComponent>
        <ButtonComponent
          bgColor="#D4B100"
          color="#FFFFFF"
          paddingY="10px"
          onClick={() => setModalState(MODAL_STATES.MODIFY_JOB)}
        >
          Modify Job
        </ButtonComponent>
        <ButtonComponent
          onClick={() => setModalState(MODAL_STATES.RESCHEDULE_JOB)}
          bgColor="#009FD4"
          color="#FFFFFF"
          paddingY="10px"
        >
          Reschedule Job
        </ButtonComponent>
        <ButtonComponent
          onClick={() => setModalState(MODAL_STATES.CANCEL_CONFIRM)}
          bgColor="#D40000"
          color="#FFFFFF"
          paddingY="10px"
        >
          Cancel Job
        </ButtonComponent>
      </div>
    ),
    [MODAL_STATES.MODIFY_JOB]: (
      <div className="flex w-full justify-between mt-6 gap-2">
        <ButtonComponent
          paddingY="10px"
          onClick={() => setModalState(MODAL_STATES.JOB_DETAILS)}
        >
          Back
        </ButtonComponent>
        <ButtonComponent
          bgColor="#3CAB5C"
          color="#FFFFFF"
          paddingY="10px"
          onClick={() => formikSubmitRef.current && formikSubmitRef.current()} // 👈 trigger Formik submit
        >
          Submit to Property Owner
        </ButtonComponent>
      </div>
    ),
    [MODAL_STATES.COMPLETE_JOB]: (
      <div className="flex w-full justify-center flex-col ">
        {/* <div className="border-b-2 border[#ECECEC]">
          <h2 className="font-[500]">Complete Job</h2>
        </div> */}

        <CompleteJobs
          modalState={modalState}
          setModalState={setModalState}
          getActiveJobs={getActiveJobs}
        />
      </div>
    ),
    [MODAL_STATES.RESCHEDULE_JOB]: (
      <div className="flex w-full justify-between mt-6">
        <ButtonComponent
          paddingY="10px"
          onClick={() => setModalState(MODAL_STATES.JOB_DETAILS)}
        >
          Back
        </ButtonComponent>
        <ButtonComponent
          bgColor="#3CAB5C"
          color="#FFFFFF"
          paddingY="10px"
          onClick={() => formikSubmitRef.current && formikSubmitRef.current()} // 👈 trigger Formik submit
        >
          Submit to Customer
        </ButtonComponent>
      </div>
    ),
    [MODAL_STATES.JOB_SUMMARY]: (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          maxWidth: "1440px",
          width: "100%",
          padding: 2,
          margin: "auto",
        }}
      >
        <Button
          sx={{
            padding: "12px 16px",
            fontSize: "16px",
            maxHeight: "48px",
            width: "6rem",
          }}
          onClick={() => setModalState("")}
          variant="outlined"
        >
          Back
        </Button>
        <Button
          sx={{
            backgroundColor: "#3CAB5C",
            padding: "12px 16px",
            fontSize: "16px",
            maxHeight: "48px",
            width: "6rem",
            "&:hover": {
              backgroundColor: "#3CAB5C",
            },
          }}
          onClick={() => setModalState("")}
          variant="contained"
          color="primary"
        >
          Exit
        </Button>
      </Box>
    ),
  };
  const content = {
    [MODAL_STATES.MANAGE_JOB]: (
      <Section sections={generateManageJob(currentSelectedData)} />
    ),

    [MODAL_STATES.JOB_DETAILS]: (
      <Section sections={generateJobDetails(currentSelectedData)} />
    ),
    [MODAL_STATES.CANCEL_JOB]:
      userData.accountType !== "VENDOR" ? (
        <div className="md:max-w-[660px]  mx-auto mb-8 px-[10px] md:px-[0px] ">
          {[
            {
              number: "(i)",
              text: "If a Member cancels more than 2 hours before a scheduled Properteasy Service appointment, there is no cancellation fee.",
            },
            {
              number: "(ii)",
              text: "If the Member cancels during the 2 hours before a scheduled Properteasy Service appointment, the Member will be charged a $125 cancellation fee.",
            },
          ].map((policy, index) => (
            <div key={index} className="flex items-start gap-3">
              <span className="text-[#242424] text-[16px] font-medium">
                {policy.number} {policy.text}
              </span>
            </div>
          ))}
        </div>
      ) : null,
    [MODAL_STATES.CANCELED_CONFIRMATION]: (
      <div className="py-[30px] px-[10px] flex flex-col md:gap-[30px] gap-[10px] max-w-[630px] mx-auto text-center">
        <h1 className="md:text-[32px] text-[20px] text-[#242424] font-medium">
          Your job has been canceled.
        </h1>
      </div>
    ),
    [MODAL_STATES.CANCEL_CONFIRM]: (
      <div className="py-[30px] px-[10px] flex flex-col md:gap-[20px] gap-[10px] max-w-[630px] mx-auto text-center">
        <h1 className="md:text-[28px] text-[18px] text-[#242424] font-medium">
          Are you sure you want to cancel this job?
        </h1>
      </div>
    ),
    [MODAL_STATES.MODIFY_JOB]: (
      <Formik
        initialValues={{ additionalWork: "", newEstimate: "", media: null }}
        validationSchema={ModifyJobSchema}
        onSubmit={async (values) => {
          // Submit proposed changes to backend
          await callApi(
            () => JobsApi.proposeChange(currentSelectedData?.id, values),
            {
              successMessage: "Changes proposed to property owner.",
              onSuccess: () => {
                setModalState("");
                getActiveJobs();
                refreshStatistics && refreshStatistics();
              },
            }
          );
        }}
      >
        {({ handleSubmit, setFieldValue, submitForm }) => {
          formikSubmitRef.current = submitForm; // 👈 store reference
          return (
            <Form
              onSubmit={handleSubmit}
              className="md:p-4 p-2 flex flex-col md:gap-4 gap-2"
            >
              <div className="rounded-[16px] border border-[#ECECEC] flex flex-col md:p-6 p-2 md:gap-8 gap-2 max-w-[720px] w-full m-auto">
                <h1 className="md:text-[32px] text-[20px] text-[#242424] text-center font-medium">
                  Is Additional Work Required?
                </h1>
                <FormField
                  type="textarea"
                  name="additionalWork"
                  label="Provide Details for Additional Work"
                  placeholder="Enter here"
                  rows={4}
                />
                <FormField
                  type="text"
                  name="newEstimate"
                  label="New Estimate"
                  placeholder="Enter here"
                />
                <FormField
                  type="file"
                  name="media"
                  label="Upload Media if Possible"
                  placeholder="Choose file"
                  accept="image/*,.pdf"
                  onChange={(e) => setFieldValue("media", e.target.files[0])}
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    ),

    [MODAL_STATES.RESCHEDULE_JOB]: (
      <Formik
        initialValues={{
          rescheduleReason: "",
          available_from: "",
          available_to: "",
          days_available: [],
        }}
        validationSchema={RescheduleJobSchema}
        onSubmit={async (values) => {
          console.log('Reschedule form values:', values);
          // Map Step6's selected slots into API shape
          const payload = {
            rescheduleReason: values.rescheduleReason,
            daysAvailable: values.days_available,
          };
          await callApi(
            () => JobsApi.proposeReschedule(currentSelectedData?.id, payload),
            {
              successMessage: "Reschedule request sent to customer.",
              onSuccess: () => {
                console.log('Reschedule proposed:', payload);
                // Close modal and refresh lists/statistics after proposing reschedule
                setModalState("");
                getActiveJobs();
                refreshStatistics && refreshStatistics();
              },
            }
          );
        }}
      >
        {({ handleSubmit, submitForm }) => {
          formikSubmitRef.current = submitForm; // 👈 store reference
          return (
            <div className="md:px-0 px-2">
              <Form
                onSubmit={handleSubmit}
                className="rounded-[16px] border border-[#ECECEC] flex flex-col my-4 gap-8 max-w-[720px] w-full md:mx-auto md:py-6 py-2 md:px-[32px] px-2"
              >
                <h1 className="md:text-[32px] text-[20px] text-[#242424] text-center font-medium">
                  Need to Reschedule This Job?
                </h1>
                <p className="md:text-[20px] text-[16px] text-[#242424] font-medium text-center">
                  Propose all time slots you’re available over the next week. The owner can pick one.
                </p>
                <FormField
                  type="textarea"
                  name="rescheduleReason"
                  label="Let the customer know why you need to reschedule:"
                  placeholder="Enter here"
                  rows={4}
                />
                {/* Use dedicated reschedule time-slot selector (separate from PostJob Step6) */}
                <RescheduleTimeSlotPicker />
              </Form>
            </div>
          );
        }}
      </Formik>
    ),
    [MODAL_STATES.JOB_CONFIRMED]: (
      <div className="py-[30px] flex flex-col gap-[30px] max-w-[630px] mx-auto text-center">
        <h1 className="md:text-[32px] text-[20px] text-[#242424] font-medium">
          Your job request has been canceled.
        </h1>
      </div>
    ),
    [MODAL_STATES.JOB_SUMMARY]: (
      <Section sections={jobSummary(currentSelectedData)} />
    ),
  };

  const handleClose = () => {
    setModalState("");
  };
  const handleManageJobClick = () => {
    if (userData.accountType === "VENDOR") {
      setModalState("jobDetails");
    } else {
      setModalState("manageJob");
    }
  };
  const title = {
    [MODAL_STATES.MANAGE_JOB]: "Manage Job",
    [MODAL_STATES.CANCEL_JOB]: "Cancel Job",
    [MODAL_STATES.CANCEL_CONFIRM]: "Confirm Cancellation",
    [MODAL_STATES.CANCELED_CONFIRMATION]: "Cancel Job",
    [MODAL_STATES.JOB_DETAILS]: "View Job Details",
    [MODAL_STATES.MODIFY_JOB]: "Modify Job",
    [MODAL_STATES.RESCHEDULE_JOB]: "Reschedule Job",
    [MODAL_STATES.JOB_SUMMARY]: "Job Summary",
    [MODAL_STATES.COMPLETE_JOB]: "Complete Job",
  };

  return (
    <>
      {loading ? (
        <CircularLoader minHeight="400px" />
      ) : (
        <Jobs
          title="Active Jobs"
          jobs={jobs}
          search={searchbarVisibilty[userData.accountType]?.activeJobs}
          onManageJobClick={handleManageJobClick}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          resultsPerPage={resultsPerPage}
          onResultsPerPageChange={handleResultsPerPageChange}
          totalCount={totalCount}
        />
      )}
      <Toaster />
      <GenericModal
        logoDetail={
          modalState === MODAL_STATES.JOB_CONFIRMED ||
          modalState === MODAL_STATES.JOB_DETAILS
            ? "You're Booked! Time to Get to Work."
            : modalState === MODAL_STATES.CANCEL_JOB ||
              modalState === MODAL_STATES.CANCEL_CONFIRM
            ? null
            : modalState === MODAL_STATES.JOB_SUMMARY
            ? "All Set! The invoice is being prepared."
            : null
        }
        logo={
          modalState === MODAL_STATES.JOB_CONFIRMED ||
          modalState === MODAL_STATES.JOB_SUMMARY ||
          ((modalState === MODAL_STATES.CANCEL_JOB ||
            modalState === MODAL_STATES.CANCEL_CONFIRM) &&
          !["LANDLORD", "PROPERTY_MANAGER", "HOMEOWNER", "STR_HOST"].includes(userData.accountType)) ||
          modalState === MODAL_STATES.JOB_DETAILS
        }
        open={Boolean(modalState)}
        onClose={handleClose}
        title={title[modalState]}
        children={content[modalState]}
        footer={footer[modalState] || null}
        maxWidth="982px"
      />
    </>
  );
};
export default ActiveJobs;
